import apiClient from "../../../utilities/apiClient";

export const get_AdminAsns = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.admin_asns_list}?page=${payload?.page}&per_page=${payload?.per_page}&search=${payload?.search_key}`,
    "",
    true
  );
};

export const view_AsnDetails = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.view_asn_details}/${payload}`,
    "",
    true
  );
};

export const approve_asn = (payload) => {
  // console.log(apiClient.Urls.asn_approve);
  // console.log(payload);
  return apiClient.post(
    `${apiClient.Urls.asn_approve}/${payload.asn_id}`,
    payload,
    true
  );
};
export const generate_link_for_arn = (payload) => {
  return apiClient.post(`${apiClient.Urls.generateLinkForArn}`, payload, true);
};
